import React,{ useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import Table  from "../../helpers/Table";
import Loading from "../../common/Loading";

import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchStatus } from "../../services/redux/reducers/commonThunk";
import { getPMBranches, updatePMBranch } from "../../services/api/pmBranch";

import { InputSwitchField } from "../../helpers";


const PMBranch = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [pmBranches, setPMBranches] = useState([])

    const dispatch = useDispatch()
   
    useEffect(() => {
        dispatch(fetchStatus())
        fetchPMBranches()
    }, [])

    const fetchPMBranches = async () => {
        const pmBranchesResponse = await getPMBranches()

        if(pmBranchesResponse.failure){
            return dispatch(raiseToast({severity:'error', detail: pmBranchesResponse.data.error, life: 3000}))
        } else {
            console.log("pmBranchesResponse", pmBranchesResponse)
            setPMBranches(pmBranchesResponse.data)
        }
    }

    const getInvoicingEnabledBody = (row) =>{
        return(
            <InputSwitchField permissions={[31,32]} onChange={(event) => handleInvoicingEnabledChange(event, row)} checked={row['isInvoicingEnabled']}/> 
        )
    }

    const tableColumns = [
        {
            header: 'Branch', field: 'companyBranch.branchName', style:{ textAlign: "center", width: "300px" }
        },
        {
            header: 'Invoicing Enabled', field : 'isInvoicingEnabled', body: getInvoicingEnabledBody, style:{ textAlign: "center", width: "300px" }
        },
        {
            header: 'Details'
        }
    ]

    const handleInvoicingEnabledChange = async (event, row) => {
        if(event.target.value){
            if(!window.confirm("Confirm to enable invoicing")){
                return
            }
        } else {
            if(!window.confirm("Confirm to disable invoicing")){
                return
            }
        }
        
        setIsLoading(true)
        const updatedResponse = await updatePMBranch(row.branchId, {isInvoicingEnabled: event.target.value})
        
        if(updatedResponse.failure){
            return dispatch(raiseToast({severity:'error', detail: updatePMBranch.data.error, life: 3000})) 
        }else{
            fetchPMBranches()
            dispatch(raiseToast({severity:'success', detail: "Updated successfully", life: 3000}))
        }
        setIsLoading(false)
    }

    return (
        <div>
            <div className="vp-credit-non-credit-layout flex flex-column">
                <div className="flex justify-content-between">
                    <h4 className="m-2">PM BRANCH</h4>
                </div>
                <div className='flex flex-row'>
                    <div className="" style={{ order: "1", width: "100%" }}>
                        <div className='p-card mb-0'>
                            <div className="flex-grow-1 petty-cash-table" >
                                <Table
                                    tableColumns={tableColumns}
                                    data={pmBranches}
                                    scrollable={"true"}
                                    //loading={isTableLoading}
                                    scrollHeight={"620px"}
                                />
                            </div>
                        </div>
                    </div>

                    <Loading visible={isLoading} />
                </div>
            </div>
        </div>
    )
}

export default PMBranch;